import { ServiceCenter } from './service-center';
import { VehiculeStatus } from '../enums/vehicule-status-enum';
import { Mission } from './mission/mission';
import { Route } from './route';
import { CenterDepartment } from './center-department';

export class Vehicle {
	id: number;
	model: string;
	name: string;
	gps: boolean;
	status: string;
	rented: boolean;
	travelledDistance: number;
	mileageCost: number;
	routes: Route[];
	serviceCenter: ServiceCenter;
	centerDepartment: CenterDepartment;

	constructor(
		options: {
			id?: number;
			model?: string;
			name?: string;
			gps?: boolean;
			status?: string;
			rented?: boolean;
			travelledDistance?: number;
			routes?: Route[];
			serviceCenter?: ServiceCenter;
		} = {}
	) {
		this.id = options.id || null;
		this.model = options.model || '';
		this.name = options.name || '';
		this.gps = options.gps || false;
		this.status = options.status || VehiculeStatus.available;
		this.rented = options.rented || false;
		this.travelledDistance = options.travelledDistance || 0;
		this.routes = options.routes || [];
		this.serviceCenter = options.serviceCenter || null;
	}
}
